module.exports = __webpack_public_path__ + "img/Camera6.b453afe0.png";